import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group fixed right-[-18px] bottom-16 z-10 w-[120px] cursor-pointer md:right-2 md:bottom-2 md:w-[184px] lg:right-[-15px] lg:bottom-[18px]',
    image: 'block h-auto w-full transition-opacity duration-200',
    hover: 'absolute inset-0 opacity-0 lg:group-hover:opacity-100'
  }
});
